import type { BlokProps } from "@trydig/storyblok";
import { CalendarIcon } from "@/components/icons/Calendar";
import { CameraIcon } from "@/components/icons/Camera";
import { EditIcon } from "@/components/icons/Edit";
import type { BlokArticleCredits } from "@/storyblok";
import BlokWrap from "../BlokWrap";
import styles from "./ArticleCreditsBlok.module.css";
import { ArticlePublishedAt } from "./components/ArticlePublishedAt";

export const ArticleCreditsBlok = ({ blok }: BlokProps<BlokArticleCredits>) => {
	if (!blok.author && !blok.illustrator && !blok.publishedAt) {
		return null;
	}

	return (
		<BlokWrap editable={blok} asChild>
			<div className={styles.root}>
				{blok.author && (
					<div className={styles.item}>
						<EditIcon />
						<p className={styles.text}>{blok.author}</p>
					</div>
				)}
				{blok.illustrator && (
					<div className={styles.item}>
						<CameraIcon />
						<p className={styles.text}>{blok.illustrator}</p>
					</div>
				)}
				{blok.publishedAt && (
					<div className={styles.item}>
						<CalendarIcon />
						<p className={styles.text}>
							<ArticlePublishedAt publishedAt={blok.publishedAt} />
						</p>
					</div>
				)}
			</div>
		</BlokWrap>
	);
};
